/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu';
import cn from 'classnames';
import { ReactComponent as ArrowRightSvg } from 'assets/icons/New/FilterBar/ArrowRight.svg';
import { ReactComponent as ArrowLeftSvg } from 'assets/icons/New/FilterBar/ArrowLeft.svg';
import { ATooltip, ASpin } from 'components/Antd';
import { onWheel } from './utils';
import classes from './HorizontalScroll.module.scss';

const Arrow = ({ isPrev, disabled, className, ...other }) => {
  return (
    <span
      {...other}
      className={cn(
        classes.arrow,
        {
          [classes.disabled]: disabled,
          [classes.isPrev]: isPrev,
        },
        className
      )}>
      {isPrev ? <ArrowLeftSvg /> : <ArrowRightSvg />}
    </span>
  );
};

const ArrowLeft = () => {
  const visibility = React.useContext(VisibilityContext);
  const isFirstItemVisible = visibility.useIsVisible('first', true);
  const onClick = () => {
    visibility.scrollToItem(visibility.getPrevElement(), 'smooth', 'start');
  };

  return (
    <Arrow onClick={onClick} disabled={isFirstItemVisible} isPrev className="scroll-arrow-left" />
  );
};
const ArrowRight = () => {
  const visibility = React.useContext(VisibilityContext);
  const isLastItemVisible = visibility.useIsVisible('last', false);
  const onClick = () => visibility.scrollToItem(visibility.getNextElement(), 'smooth', 'end');

  return <Arrow disabled={isLastItemVisible} onClick={onClick} className="scroll-arrow-right" />;
};

const HorizontalScroll = ({ className, items, onAction, box, isAsync, noGap }) => {
  const [loading, setLoading] = React.useState({});
  return (
    <div
      className={cn(
        classes.wrapper,
        {
          [classes.box]: !!box,
          [classes.noGap]: noGap,
        },
        className
      )}>
      <ScrollMenu LeftArrow={ArrowLeft} RightArrow={ArrowRight} onWheel={onWheel}>
        {items.map((tObj, index) => {
          const { label, disabled, icon, iconAction, tooltip, children } = tObj;
          const isLoading = !!loading[index];
          const el = children || (
            <span
              className={cn(classes.card, {
                [classes.available]: !disabled && !iconAction,
                [classes.disabled]: disabled,
                [classes.iconActionOnly]: !!iconAction,
                [classes.isLoading]: isLoading,
              })}
              onClick={
                !disabled && !isLoading && !iconAction
                  ? () => {
                      onAction(
                        tObj,
                        () => {
                          if (isAsync) {
                            setLoading({
                              ...loading,
                              [index]: true,
                            });
                          }
                        },
                        () => {
                          if (isAsync) {
                            setLoading({
                              ...loading,
                              [index]: false,
                            });
                          }
                        }
                      );
                    }
                  : undefined
              }>
              <span
                className={cn(classes.label, {
                  [classes.loading]: isLoading,
                })}>
                {(!!icon || isLoading) && (
                  <span
                    className={cn(classes.iconAction, {
                      [classes.clickable]: !!iconAction,
                    })}
                    onClick={iconAction}>
                    {isLoading ? <ASpin indicator={<LoadingOutlined spin />} /> : icon}
                  </span>
                )}
                <span>{label}</span>
              </span>
            </span>
          );
          return !!tooltip ? (
            <ATooltip
              dark
              title={disabled ? '' : tooltip}
              placement="bottom"
              key={index}
              overlayClassName={classes.tooltipOverlay}>
              <div>{el}</div>
            </ATooltip>
          ) : (
            <React.Fragment key={index}>{el}</React.Fragment>
          );
        })}
      </ScrollMenu>
    </div>
  );
};

export default HorizontalScroll;
